module.exports = __webpack_public_path__ + "static/media/unauthorized-person.48e53e46.svg";